import $http from "../axios";

const state = {
  purchases: [],
  purchasesQty: 0
};

const getters = {
  purchases: state => {
    return state.purchases;
  },
  purchasesQty: state => {
    return state.purchasesQty;
  }
};

const actions = {
  getPurchases({ commit }, data = {}) {
    return new Promise((resolve, reject) => {
      $http
        .get("purchases", { params: { ...data } })
        .then(res => {
          if (res.data.result === "ok") {
            commit("SET_PURCHASES", res.data.payload);
          }
          resolve(res);
        })
        .catch(e => {
          reject(e);
        });
    });
  },

  getAllPurchases({ commit }) {
    return new Promise((resolve, reject) => {
      const requestedLimit = 1000;

      $http
        .get("purchases", {
          params: {
            skip: 0,
            limit: requestedLimit,
            sortField: "n",
            sortOrder: "asc"
          }
        })
        .then(async res => {
          if (res.data.result !== "ok") {
            resolve(res);
            return;
          }

          const payload = res.data.payload || {};
          const firstBatch = payload.purchases || [];
          const purchasesQty = payload.purchasesQty || firstBatch.length;
          const pageSize = firstBatch.length || requestedLimit;

          if (purchasesQty <= firstBatch.length || pageSize === 0) {
            commit("SET_PURCHASES", payload);
            resolve(res);
            return;
          }

          const requests = [];
          for (
            let skip = firstBatch.length;
            skip < purchasesQty;
            skip += pageSize
          ) {
            requests.push(
              $http.get("purchases", {
                params: {
                  skip,
                  limit: pageSize,
                  sortField: "n",
                  sortOrder: "asc"
                }
              })
            );
          }

          const responses = await Promise.all(requests);
          const remainingPurchases = responses.flatMap(response => {
            return response.data.payload.purchases || [];
          });

          commit("SET_PURCHASES", {
            purchasesQty,
            purchases: [...firstBatch, ...remainingPurchases]
          });

          resolve({
            ...res,
            data: {
              ...res.data,
              payload: {
                ...payload,
                purchasesQty,
                purchases: [...firstBatch, ...remainingPurchases]
              }
            }
          });
        })
        .catch(e => {
          reject(e);
        });
    });
  },

  savePurchase({ commit }, data) {
    return new Promise((resolve, reject) => {
      $http
        .post("save-purchase", data)
        .then(res => {
          if (res.data.result === "ok") {
            const payload = res.data.payload || {};
            commit(
              "UPDATE_PURCHASE",
              payload.product || payload.purchase || data.product
            );
          }
          resolve(res);
        })
        .catch(e => {
          reject(e);
        });
    });
  },

  removePurchases({ commit }, data) {
    const barcodes = (data.barcodes || []).map(b => b.toString());

    return new Promise((resolve, reject) => {
      $http
        .post("remove-purchase", { barcodes })
        .then(res => {
          if (res.data.result === "ok") {
            barcodes.forEach(barcode => commit("REMOVE_PURCHASE", barcode));
          }
          resolve(res);
        })
        .catch(e => {
          reject(e);
        });
    });
  },

  bulkAddPurchases(_, data) {
    return new Promise((resolve, reject) => {
      $http
        .post("bulk-add-purchases", data)
        .then(res => {
          resolve(res);
        })
        .catch(e => {
          reject(e);
        });
    });
  },

  clearPurchases({ commit }) {
    commit("CLEAR_PURCHASES");
  }
};

const mutations = {
  SET_PURCHASES(state, payload) {
    state.purchasesQty = payload.purchasesQty || 0;
    state.purchases = (payload.purchases || []).map(p => {
      p.lc /= 100;
      return p;
    });
  },
  UPDATE_PURCHASE(state, product) {
    const index = state.purchases.findIndex(p => {
      return p.b === product.b;
    });
    if (index === -1) {
      state.purchases.push({
        ...product,
        lc: product.lc / 100
      });
      state.purchasesQty += 1;
    } else {
      state.purchases = state.purchases.map(p => {
        return p.b === product.b ? { ...product, lc: product.lc / 100 } : p;
      });
    }
  },
  REMOVE_PURCHASE(state, barcode) {
    const index = state.purchases.findIndex(p => {
      return p.b === barcode;
    });
    if (index > -1) {
      state.purchases.splice(index, 1);
      state.purchasesQty = Math.max(0, state.purchasesQty - 1);
    }
  },
  CLEAR_PURCHASES(state) {
    state.purchases = [];
    state.purchasesQty = 0;
  }
};

export default {
  state,
  getters,
  actions,
  mutations
};
